import homepage from "../../home/images/homepage2.jpg";
import { Button } from "@mui/material";
import { AdminNav } from "../mini-components/admin_nav";
import { useState } from "react";
import "./HomepageImage.css";
import { useEffect } from "react";
import axios from "axios";
import { url } from "../../weburl";
import Swal from "sweetalert2";
import { AdminSidePane } from "../mini-components/admin-side-pane";
import { AdminMainWrapper } from "../mini-components/admin-main-wrapper";

export const HomepageImage = () => {
  const image = [homepage, homepage, homepage, homepage, homepage];
  const [file, setFile] = useState("");
  const [btnState, setBtnState] = useState({ disabled: true, text: "Upload" });
  const [modalInfo, setModalInfo] = useState({ show: false, img: null });
  const [galleryImages, setGalleryImages] = useState([]);

  const imageUploadHandler = () => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "gwxgv5ii");
    setBtnState({ disabled: true, text: "Uploading..." });

    axios
      .post("https://api.cloudinary.com/v1_1/daurieb51/image/upload", formData) //upload to cloudinary
      .then((response) => {
        console.log(response);
        setBtnState({ disabled: true, text: "Almost done..." }); //change button text and disable it
        axios
          .post(`${url}api/content/gallery-images`, {
            publicId: response.data.public_id,
          }) //upload to database
          .then((response) => {
            setBtnState({ disabled: false, text: "Uploaded" }); //change button text
          })
          .catch((err) => {
            console.log(err);
            setBtnState({ disabled: false, text: "Upload" }); //catch error in sending to database and change button text
          });
      })

      .catch((err) => {
        console.log(err);
        setBtnState({ disabled: false, text: "Upload" }); //catch error in uploading to cloudinary and change button text
      });
  };
  const fetchImages = async () => {
    try {
      const res = await axios.get(`${url}api/content/gallery-images`);
      setGalleryImages(res.data);
      console.log(galleryImages);
    } catch (error) {
      console.log(error);
    }
  };
  const deleteImageHandler = async () => {

    Swal.fire({
      title: 'Are you sure you want to delete this image?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: `No`,
    }).then((result) => {

      if (result.isConfirmed) {
        axios.delete(
          `${url}api/content/gallery-images/${modalInfo.img}`
        )
          .then((res) => {
            fetchImages();
            setModalInfo({ show: false })


          })
          .catch((err) => {
            console.log(err);

          })
        Swal.fire('Deleted!', '', 'success')
      }
      else if (result.isDenied) {
        Swal.fire('Changes are not saved', '', 'info')

      }
    });
  }
  // const updateImageHandler = () => {};

  useEffect(() => {
    fetchImages();
  }, []);

  return (
    <AdminMainWrapper>
      <div className="row align-items-start justify-content-around">

        <div className="col-sm-12
        align-content-center justify-content-start">

          <h6>GALLERY IMAGES</h6>

          <div className="
          row align-items-center justify-content-center
          w-100 my-2 mb-4">
            <input
              type="file"
              onChange={(e) => {
                setFile(e.target.files[0]);

                setBtnState({ disabled: false, text: "Upload" });
              }}
            />
            <button
              className="admin-homepage__upload-btn px-4"
              disabled={btnState.disabled}
              onClick={imageUploadHandler}
            >
              {btnState.text}
            </button>
          </div>
          <div className="container">
            <div className="row align-items-center justify-content-center">
              {galleryImages?.map((image) => (
                <div
                  className="col-sm-6 col-md-4 col-lg-3 my-2 "
                  onClick={() =>
                    setModalInfo({ show: true, img: image.galleryImagesPublicId })
                  }
                >
                  <img src={`https://res.cloudinary.com/daurieb51/image/upload/v1642082142/${image.galleryImagesPublicId}.png`}
                    className="admin-homepage__image w-100"
                    alt="" />
                </div>
              ))}
            </div>
          </div>
          {/* <!-- The Modal --> */}
          {modalInfo?.show && (
            <div
              id="myModal"
              className="modal pt-4"
              onClick={(e) => {
                e.target.className === "modal" && setModalInfo({ show: false });
              }}
            >
              <span
                className="close"
                onClick={() => {
                  setModalInfo({ show: false });
                }}
              >
                &times;
              </span>
              <button className="btn btn-danger mb-3" onClick={deleteImageHandler}>
                Delete
              </button>

              <img className="modal-content" alt="" src={`https://res.cloudinary.com/daurieb51/image/upload/v1642082142/${modalInfo.img}.png`} />
              <div className="caption">

              </div>
            </div>
          )}
        </div>
      </div>
    </AdminMainWrapper>
  );
}